export const colors = ['#dd7c62', '#f68979', '#ebcaae', '#a7e6db', '#7bd5c5', '#43bcb4']
